import React, { ComponentProps, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { Icon } from '@/components/Icon/Icon'
import { IconButton } from '@/components/IconButton/IconButton'
import { pxToRem } from '@/shared/styles/themes'
// @ts-nocheck
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons/faCircleXmark'
import { Container, styled } from '@mui/material'

export type ModalProps = Omit<
ComponentProps<typeof ModalOverlayWrapper>,
'open' | 'fadeAnimationTime'
> & {
  open?: boolean
  animationDuration?: number
  portal?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose?: any
}

export const MobileSearchBarModal: React.FC<ModalProps> = ({
  open,
  portal = '#search',
  onClose,
  animationDuration = 0,
  children,
  ...props
}) => {
  const [portalElement, setPortalElement] = useState<Element | null>(null)

  const onModalClose: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement> = (e) => {
    e.stopPropagation()
    e.preventDefault()

    onClose()
  }

  const inner = (
    <ModalOverlayWrapper open={Boolean(open)} fadeAnimationTime={animationDuration} {...props}>
      <StyledMobileSearchBarContainer maxWidth="md">
        {children}
        <StyledCloseButton onClick={onModalClose}>
          <StyledCloseIcon icon={faCircleXmark} />
        </StyledCloseButton>
      </StyledMobileSearchBarContainer>
      <Background onClick={onModalClose} />
    </ModalOverlayWrapper>
  )

  useEffect(() => {
    const portalEl = document.querySelector(portal)

    setPortalElement(portalEl)
  }, [setPortalElement, portal])

  if (!open) {
    return null
  }

  return portalElement ? createPortal(inner, portalElement) : inner
}

export const Background = styled('div')`
  width: 100%;
  height: 100%;
`

export const StyledCloseButton = styled(IconButton)`
  padding: 0;
  margin-left: ${pxToRem(12)};
`

export const StyledCloseIcon = styled(Icon)`
  color: ${props => props.theme.palette.text.disabled};
  font-size: ${pxToRem(24)};
`

export const ModalOverlayWrapper = styled('div') <{ open: boolean; fadeAnimationTime: number }>`
  position: fixed;
  width: 100%;
  height: 100vh;
  overflow: visible;
  background: transparent;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${props => props.theme.zIndex.appBar + 200};
  overflow-y: hidden;
`

export const StyledMobileSearchBarContainer = styled(Container)`
  top: 0;
  left: 0;
  right: 0;
  height: ${pxToRem(70)};
  padding: 0 ${pxToRem(16)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.palette.background.default};
`
